import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { IBaseAction } from "../Actions/IAction";
import { DropDownMenu } from "./DropDownMenu";
import { SeparatorMenuItem } from "./SeparatorItem";

export class SeparatorMenuItemWithText extends SeparatorMenuItem {
    private _locKey: string;

    protected override _isRendered: boolean = false;

    public override icon: string;
    public override priority: number = 15;
    public override action: IBaseAction;
    public override parent: DropDownMenu;
    public override isOpened: boolean;

    public set locKey(v: string) {
        this._locKey = v;

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._textElement.textContent = locItem;
            });
        }
    }

    public get locKey(): string {
        return this._locKey;
    }

    protected override _constructor(): void {
        super._constructor();

        this.priority = 15;
    }

    public static createSeparatorWithText(locKey: string): SeparatorMenuItemWithText {
        const elem = new SeparatorMenuItemWithText();
        elem.locKey = locKey;
        Localization.addLocTxtData(elem._textElement, locKey, undefined, undefined, true);
        return elem;
    }

    protected override _createElement(): void {
        this.classList.add("SeparatorText");
        this._textElement = document.createElement("div");

        this._textElement.classList.add("Text");

        this.appendChild(this._textElement);
        super._createElement();
    }
}

registerCustomElement("tsc-SeparatorMenuItemWithText", SeparatorMenuItemWithText);
